import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import jwt from 'jwt-decode';

import Home from './views/Home';
import Dashboard from './views/Dashboard';
import DashboardSummary from './views/Dashboard/summary';
import DashboardPerformance from './views/Dashboard/performance';
import DashboardUsers from './views/Dashboard/users';
import LoadingOverlay from './components/Common/LoadingOverlay';
import NotFound from './views/404';

import Api from './api';
import AuthContext from './auth-context';

const delay = (s: number) => new Promise((r) => setTimeout(r, s * 1000));

const UnAuthenticatedAppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const AuthenticatedAppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/summary" element={<DashboardSummary />} />
      <Route path="/performance" element={<DashboardPerformance />} />
      <Route path="/users" element={<DashboardUsers />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

function App() {
  const [authenticated, setAuthenticated] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState(true);

  const location = useLocation();

  const _fetch = async () => {
    try {
      const res = await Api.check(localStorage.getItem('token') as string);
      const { tableauToken } = res;
      localStorage.setItem('tableauToken', tableauToken);
      setAuthenticated(true);
    } catch (err) {
      console.log(err);
      localStorage.clear();
    } finally {
      await delay(0.5);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    const _token = localStorage.getItem('token');

    if (_token) {
      _fetch();
    } else {
      setLoading(false);
    }
  }, [location.key]);

  if (loading) {
    return (
      <LoadingOverlay />
    );
  }

  return (
    <AuthContext.Provider value={{ authenticated, setAuthenticated }}>
      {
        !!authenticated && (
          <AuthenticatedAppRouter />
        )
      }
      {
        !authenticated && (
          <UnAuthenticatedAppRouter />
        )
      }
    </AuthContext.Provider>
  );
}

function AppRouterWrapper() {
  return (
    <BrowserRouter>
      <React.Suspense>
        <App />
      </React.Suspense>
    </BrowserRouter>
  );
}

export default AppRouterWrapper;
